import { render, staticRenderFns } from "./DHRImageView.vue?vue&type=template&id=2622283e&scoped=true&"
import script from "./DHRImageView.vue?vue&type=script&lang=js&"
export * from "./DHRImageView.vue?vue&type=script&lang=js&"
import style0 from "./DHRImageView.vue?vue&type=style&index=0&id=2622283e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622283e",
  null
  
)

export default component.exports